export default "__VITE_ASSET__Bwjp$Pzp__"